import React from "react";
import Toggle from "../Toggle/Toggle";
import { useThemeContext, ThemeMode } from '@/contexts/color-theme';
import styles from "./ThemeSwitcher.module.scss";

export const ThemeSwitcher = (): JSX.Element => {
    const { mode, toggleColorMode } = useThemeContext();
    const isDarkMode = mode === ThemeMode.dark;

    return (
        <div className={styles.container}>
            <img src={`images/footer/theme-light${!isDarkMode ? "-active" : ""}.svg`}
                alt="light theme switch" />
            <Toggle
                on={isDarkMode}
                onChange={toggleColorMode}
                className={styles.customToggle}
            />
            <img src={`images/footer/theme-dark${isDarkMode ? "-active" : ""}.png`}
                alt="dark theme switch" />
        </div>
    );
};

export const useThemeSwitcher = (isForceAction?: boolean): () => void => {
    const { toggleColorMode } = useThemeContext();

    const switchColorTheme = () => {
        if (window.location.host?.includes("localhost") || isForceAction) {
            toggleColorMode();
        }
    };

    return switchColorTheme;
};
